import styled from 'styled-components';
import { v2Colors, v2FontFamily, v2Breakpoints } from '../../../../formInputsV2/styles/tokens';
import {
  AiChatButton,
  CompanyInfoElements,
  CompanyInformationContainer,
  LogoContainer,
  LogoPriceContainer,
  Price,
  PriceContainer,
  QuoteInformationContainer,
  QuoteInformationItem,
} from './QuotationCard.styles';

const STACK_BELOW = '1500px';

export {
  CompanyInfoElements,
  CompanyInformationContainer,
  LogoContainer as LogoResultContainer,
  LogoPriceContainer,
  Price as PriceResult,
  PriceContainer,
  QuoteInformationContainer as EuropQuoteInformationResultContainer,
  QuoteInformationItem as QuoteInformationResultItem,
};

// Same in-flow tonal chip as the other v2 cards, replacing the old bold
// gradient-filled button.
export const AiChatButtonEuropeassistance = AiChatButton;

// Pinned to the card's own top-right corner (same technique as the other v2
// selected-quote cards) instead of sitting inside RightColResult's flex flow
// — in that flow it only looked right in the two-column desktop layout; once
// the card stacks to one column on mobile it ended up stranded in a gap
// between the details and the "Garanzie Aggiunte" box.
export const AiChatButtonWrapper = styled.div`
  position: absolute;
  top: 16px;
  right: 20px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    top: 14px;
    right: 16px;
  }
`;

const cardBase = `
  position: relative;
  display: flex;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  height: 100%;
  padding: 16px 20px;
  background: ${v2Colors.inputBackground};
  border: 1px solid ${v2Colors.disabledBorder};
  border-radius: 16px;
  box-shadow: 0 2px 8px rgba(16, 24, 40, 0.05);
  font-family: ${v2FontFamily};

  &.selected {
    border-color: ${v2Colors.primary};
    box-shadow: 0 0 0 3px ${v2Colors.primarySoftHover};
  }

  ${CompanyInformationContainer}:empty {
    display: none;
  }

  /* Icon-only past this width, same as the other v2 selected-quote cards —
     shrinks the pinned AI button's footprint so it stays clear of the
     "Garanzie Aggiunte" box below it once the card narrows. */
  @media (max-width: ${STACK_BELOW}) {
    ${AiChatButton} {
      padding: 8px;

      span {
        position: absolute;
        width: 1px;
        height: 1px;
        overflow: hidden;
        clip: rect(0 0 0 0);
        white-space: nowrap;
      }
    }
  }

  @media (max-width: ${STACK_BELOW}) {
    flex-direction: column;
    gap: 16px;
    padding: 14px 16px;
  }
`;

export const EuropeassistanceCardResultStyles = styled.div`${cardBase}`;

export const EuropeassistanceRiskCardStyles = styled.div`${cardBase}
  min-height: 180px;

  @media (max-width: ${v2Breakpoints.tablet}) {
    min-height: 0;
  }
`;

export const LeftColResult = styled.div`
  flex: 1 1 auto;
  min-width: 0;
`;

export const RightColResult = styled.div`
  display: flex;
  flex: 0 0 34%;
  flex-direction: column;
  gap: 12px;
  min-width: 260px;
  max-width: 360px;
 
  margin-top: 52px;

 
  @media (max-width: ${STACK_BELOW}) {
    flex: 0 0 auto;
    width: 100%;
    min-width: 0;
    max-width: none;
    margin-top: 0;
  }
`;

export const SelectedGuaranteesContainerResult = styled.div`
  width: 100%;
  padding: 14px 16px;
  border: 1px solid ${v2Colors.disabledSurface};
  border-radius: 12px;
  background: ${v2Colors.surface};

  h2,
  h5 {
    margin: 0 0 8px;
    color: ${v2Colors.textMuted};
    font-family: ${v2FontFamily};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.3;
    text-align: left;
  }

  h2 b,
  h5 b {
    color: ${v2Colors.text};
    font-weight: 700;
  }
`;

export const GuaranteesListResult = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  width: 100%;
`;

export const GuaranteesListItemResult = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  width: 100%;

  h6 {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin: 0;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 13px;
    font-weight: 500;
    line-height: 1.35;

    &::before {
      content: '';
      flex-shrink: 0;
      width: 6px;
      height: 6px;
      margin-top: 6px;
      border-radius: 50%;
      background: ${v2Colors.primary};
    }

    /* the markup puts an empty <span /> before the title; as a flex item it would add a gap */
    span:empty {
      display: none;
    }
  }

  p {
    margin: 0;
    color: ${v2Colors.text};
    font-family: ${v2FontFamily};
    font-size: 13px;
    font-weight: 600;
    line-height: 1.35;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
  }
`;
